import React from 'react';
import './Carico.css';

interface WidgetProps {
  onClose: () => void;
  className?: string;
}

const Carico: React.FC<WidgetProps> = ({ onClose, className }) => {
  return (
    <div className={`widget-card carico-widget ${className || ''}`}>
      <div className="widget-header">
        <h3>Carico</h3>
        <button onClick={onClose} className="widget-close-btn" aria-label="Chiudi widget Carico">
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="widget-content">
        <p>Gestione e visualizzazione del carico...</p>
      </div>
    </div>
  );
};

export default Carico; 